<template>
    <div id="kartenAuswahlContainer">
    <div id="kartenAuswahlBackground" class="kartenAuswahlBGMove" v-if="this.$props.kartenAuswahlActive" @click="this.$emit('kartenAuswahlActive', false)" :class="{ kartenAuswahlBGActiveMove: this.$props.kartenAuswahlActive, kartenAuswahlBGDeactiveMove: !this.$props.kartenAuswahlActive }"></div>
    <div id="kartenAuswahl"  class="kartenAuswahlMove" :class="{ kartenAuswahlActiveMove: this.$props.kartenAuswahlActive, kartenAuswahlDeactiveMove: !this.$props.kartenAuswahlActive }">
    <span>
        <h3>Kartenarten:</h3>
        <div class="kartenAuswahlButtonContainer">
        <button>
        <router-link :to="`/hydranten/`+this.$route.params.id">
            <img src="@/assets/mapAuswahl/HydrantenmapAuswahl.png" :class="{ auswahlButtonActive: (mapObj == 'hydrant') }">
            <p>Hydranten</p>
        </router-link>
        </button>
        <button>
        <router-link :to="`/hilfeimwald/`+this.$route.params.id">
            <img src="@/assets/mapAuswahl/HIWmapAuswahl.png" :class="{ auswahlButtonActive: (mapObj == 'hiw') }">
            <p>Hilfe im Wald</p>
        </router-link>
        </button>
        <button>
        <router-link :to="`/sammelpunkte/`+this.$route.params.id">
            <img src="@/assets/mapAuswahl/SammelpunktemapAuswahl.png" :class="{ auswahlButtonActive: (mapObj == 'sammelpunkte') }">
            <p>Sammelpunkte</p>
        </router-link>
        </button>
        <!--<button disabled>
        <img src="@/assets/mapAuswahl/BrandmeldeanlagenmapAuswahl.png" :class="{ auswahlButtonActive: (mapObj == 'bma') }">
        <p>Brandmeldeanlagen</p>
        </button>-->
        </div>
        <br>
        <h3>Kartendetails:</h3>
        <div class="kartenAuswahlButtonContainer">
        <button @click="this.$emit('switchHydrantenVisibility')">
        <img src="@/assets/KartenIcons/Hydrant.svg" :class="{ auswahlButtonActive: hydrantenVisible }">
        <p>Hydranten</p>
        </button>
        <button @click="this.$emit('switchLeitungenVisibility')">
        <img src="@/assets/KartenIcons/Leitung.png" :class="{ auswahlButtonActive: leitungenVisible }">
        <p>Leitungen</p>
        </button>
        <button @click="this.$emit('switchRettungspunkteVisibility')">
        <img src="@/assets/KartenIcons/Sammelpunkte.png" :class="{ auswahlButtonActive: rettungspunkteVisible }">
        <p>HIW-Punkte</p>
        </button>
        <button @click="this.$emit('switchSammelpunkteVisibility')">
        <img src="@/assets/KartenIcons/Sammelpunkte.png" :class="{ auswahlButtonActive: sammelpunkteVisible }">
        <p>Sammelpunkte</p>
        </button>
        <button v-if="1 == 2" disabled>
        <img src="@/assets/KartenIcons/BMA.png">
        <p>BMA's</p>
        </button>
        <button v-if="1 == 2" disabled>
        <img src="@/assets/KartenIcons/Bild1.png">
        <p>Wichtige Gebäude</p>
        </button>
        </div>
    </span>
    </div>
</div>
</template>

<script>
export default {
  name: "KartenAuswahl",
  props: {
    kartenAuswahlActive: Boolean,
    mapObj: String,
    hydrantenVisible: Boolean,
    leitungenVisible: Boolean,
    rettungspunkteVisible: Boolean,
    sammelpunkteVisible: Boolean
  },
  methods: {
    switchHydrantenVisibility() {
      this.$emit("switchHydrantenVisibility");
    },
    switchLeitungenVisibility() {
      this.$emit("switchLeitungenVisibility");
    },
    switchRettungspunkteVisibility() {
      this.$emit("switchRettungspunkteVisibility");
    },
    switchSammelpunkteVisibility() {
      this.$emit("switchSammelpunkteVisibility");
    }
  }
};
</script>

<style lang="scss" scoped>
.auswahlButtonActive{
border: solid 0.3px blue;
box-shadow: 0 0 1px 1px rgba(0, 17, 255, 0.87) !important;
}

.kartenAuswahlBGActiveMove{
opacity: 1;
}

.kartenAuswahlBGDeactiveMove{
opacity: 0;
}

.kartenAuswahlBGMove{
transition: opacity 10s;
}

kartenAuswahlActiveMove{
transform: translateY(0rem);
}

.kartenAuswahlDeactiveMove{
transform: translateY(70vh);
}

.kartenAuswahlMove{
transition: transform 0.3s ease;
}

#kartenAuswahl{
background-color: white;
position: fixed;
bottom: 0;
width: 100vw;
height: 70vh;
z-index: 500;
display: flex;
justify-content: center;

a{
    text-decoration: none !important;
    color: black !important;
}

span{
    display:inline-block;
    width: auto;
    height: 70vh;
}

h3{
    margin-left: 1.5rem;
    display: flex;
    justify-content: left;
    margin-bottom: 0.5rem;
}

.kartenAuswahlButtonContainer{
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    height: auto;
    width: auto;
    margin-left: 1rem;
    align-items: flex-start;

    button{
    padding: 0;
    width: 21vw;
    max-width: 9rem;
    margin: 0.2rem;
    border: none;
    background:none;

    img{
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        border-radius: 10px;
        box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.349);
    }

    p{
        margin-top: 0.1rem;
        hyphens: auto;
        word-wrap: break-word;
        overflow-wrap: break-word;
        text-align: center;
        margin: 0;
    }
    }
}
}

#kartenAuswahlBackground{
background-color:rgba(0, 0, 0, 0.8);
position: fixed;
top: 0;
left: 0;
height: 100vh;
width: 100vw;
z-index: 499;
}
</style>